import { useAuthContext } from './useAuthContext';
import { getManageSubscriptionPath } from '/src/features/_global/utils';

export function useManageSubscriptionPath() {
  const { currentAccount } = useAuthContext();
  const isShopifyUser = Boolean(currentAccount?.isShopifyUser);

  return getManageSubscriptionPath(isShopifyUser);
}
